module.exports = __webpack_public_path__ + "img/gift4-01-c02-k1.0ce9b2b1.png";